<ng-container *ngrxLet="{ shouldOpenOnHover: shouldOpenOnHover$, isOpen: isOpen$, popoverText: popoverText$ } as vm">
    <dtm-ui-icon
        class="popover-icon"
        [name]="popoverIcon$ | ngrxPush"
        cdkOverlayOrigin
        #popoverTrigger="cdkOverlayOrigin"
        (click)="!vm.shouldOpenOnHover && clickOpen()"
        (keydown.enter)="toggleOverlay()"
        (keydown.space)="toggleOverlay()"
        (keydown.tab)="hidePopover()"
        (keydown.shift.tab)="hidePopover()"
        (mouseenter)="vm.shouldOpenOnHover && showPopover()"
        (mouseleave)="vm.shouldOpenOnHover && hidePopover()"
        tabindex="0"
    >
        <div class="pointer" #pointerHost></div>
    </dtm-ui-icon>

    <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="popoverTrigger"
        (positionChange)="positionChange($event, pointerHost)"
        (detach)="removePointerClasses(pointerHost)"
        (overlayOutsideClick)="clickClose()"
        [cdkConnectedOverlayOpen]="!!vm.isOpen"
    >
        <div class="popover-tooltip" [style.max-width]="maxWidth$ | ngrxPush" #popoverTooltip>
            <div class="popover-body">
                <ng-container *ngIf="vm.popoverText; else customTooltip">{{ vm.popoverText }}</ng-container>
            </div>
        </div>
    </ng-template>

    <ng-template #customTooltip>
        <ng-content></ng-content>
    </ng-template>
</ng-container>
